module.exports = __webpack_public_path__ + "assets/i18n/pt.json";


//////////////////
// WEBPACK FOOTER
// ./src/i18n/pt.json
// module id = 1206
// module chunks = 0